module.exports = __webpack_public_path__ + "img/10.8d50da84.jpg";